module.exports = __WEBPACK_EXTERNAL_MODULE_core_Maths_math_vector__;